(function () {
  var DURATION = 360;
  var EASING = 'ease-out';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function content(details) {
    return details.querySelector('.ibscent-pdp__accordion-content');
  }

  function expand(details) {
    var el = content(details);
    if (!el) { details.open = true; return; }
    details.open = true;
    if (reduce) return;
    var end = el.scrollHeight;
    el.style.overflow = 'hidden';
    var anim = el.animate([{ height: '0px' }, { height: end + 'px' }], { duration: DURATION, easing: EASING });
    anim.onfinish = function () { el.style.height = ''; el.style.overflow = ''; };
  }

  function collapse(details) {
    var el = content(details);
    if (!el) { details.open = false; return; }
    if (reduce) { details.open = false; return; }
    var start = el.scrollHeight;
    el.style.overflow = 'hidden';
    var anim = el.animate([{ height: start + 'px' }, { height: '0px' }], { duration: DURATION, easing: EASING });
    anim.onfinish = function () { details.open = false; el.style.height = ''; el.style.overflow = ''; };
  }

  function closeSiblings(details) {
    var group = details.closest('.ibscent-pdp__accordions');
    if (!group) return;
    var open = group.querySelectorAll('.ibscent-pdp__accordion[open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== details) collapse(open[i]);
    }
  }

  function onClick(e) {
    var summary = e.target.closest('.ibscent-pdp__accordion-summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.classList.contains('ibscent-pdp__accordion')) return;
    e.preventDefault();
    if (details.dataset.animating === '1') return;
    details.dataset.animating = '1';
    setTimeout(function () { details.dataset.animating = ''; }, DURATION + 20);
    if (details.open) {
      collapse(details);
    } else {
      closeSiblings(details);
      expand(details);
    }
  }

  document.addEventListener('click', onClick);
})();
